import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@material-ui/core";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  ForgotPassword,
  VerifyOTPForgotPassword,
} from "../../service/action-creators/authAction";
import Loader from "../Loader";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state?.auth);
  const isLoading = auth?.isLoading;
  const [clickState, setClickState] = React.useState(false);

  const [formData, setFormData] = React.useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData === "") {
      toast.error("Please email field cannot be empty");
    } else {
      dispatch(ForgotPassword(formData));
    }
    setFormData(null);
    // handleClose()
    setClickState(true);
  };

  const handleSubmitOptCode = (e) => {
    e.preventDefault();
    if (formData === "") {
      toast.error("Please email field cannot be empty");
    } else {
      // /account/password-reset
      dispatch(VerifyOTPForgotPassword(formData));
    }
    setFormData(null);
    handleClose();
  };

  const handleClose = () => {
    props.close(false);
  };

  // React.useEffect(() =>{
  //   if(response?.state === "SUCCESS"){
  //     toast.success(response?.message)
  //     setTimeout(() => {
  //       dispatch(ResetResponse())
  //     },1500)
  //   }else if(response?.state === "ERROR"){
  //     toast.error(response?.message)
  //     setTimeout(() => {
  //       dispatch(ResetResponse())
  //     },1500)
  //   }
  // },[response?.state])

  return (
    <div>
      {isLoading && <Loader />}
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Slide in alert dialog
      </Button> */}

      {clickState ? (
        <Dialog
          open={props.open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Enter OTP Code"}</DialogTitle>
          <DialogContent>
            {/* <DialogContentText id="alert-dialog-slide-description">
          Enter OPT CODE
          </DialogContentText> */}
            {/* <label htmlFor='phone_number'>OPT CODE</label> */}
            <input
              type={"number"}
              placeholder={"XXXX"}
              name="opt_code"
              id="otp_code"
              onChange={handleChange}
              className="form-control"
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{ background: "var(--primaryColor)", color: "white" }}
              onClick={handleSubmitOptCode}
            >
              Continue{" "}
            </Button>
            <Button
              style={{ background: "var(--grayColor)", color: "black" }}
              onClick={handleClose}
            >
              Cancel Reset
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog
          open={props.open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Forgot Your Password?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              We'll send OTP code to your phone number and email
            </DialogContentText>
            <label htmlFor="phone_number">Phone Number</label>
            <input
              type={"number"}
              placeholder={"0242XXXXXX"}
              name="phone_number"
              id="phone_number"
              onChange={handleChange}
              className="form-control"
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{ background: "var(--primaryColor)", color: "white" }}
              onClick={handleSubmit}
            >
              Continue{" "}
            </Button>
            <Button
              style={{ background: "var(--grayColor)", color: "black" }}
              onClick={handleClose}
            >
              Cancel Reset
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <ToastContainer autoClose={3000} />
    </div>
  );
}
